import Vue from 'vue'
import AppConfig from './config/AppConfig'

Vue.use((Vue.prototype.$config = AppConfig.load()))
